import { useState, useEffect } from "react";
import { Button, Card, CardBody, Input, Table } from "reactstrap";
// service
import { getReport } from "../../services/ache";
// componentes
import Pagination from "../../components/pagination";

export default function ReportAche() {
  //Pagination
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  //   dados de listagem
  const [list, setList] = useState([]);
  // id do evento
  //   const idEvent = "94eb6efb-fc61-4897-a153-c7597c8a73f5";
  const idEvent = "3f4a980e-5150-47e9-aac1-9f0ec73319fd";

  async function getData() {
    try {
      const res = await getReport({
        idEvent,
        limit: itemsPerPage,
        offset: currentPage,
        columnSearch: "name",
        search,
      });

      console.log("res", res);
    } catch (error) {
      console.log("get erro", error);
      setList([]);
    }
  }

  useEffect(() => {
    getData();
  }, [search, itemsPerPage, currentPage]);

  return (
    <>
      <div className="report-container">
        <Card className="card-container">
          <CardBody>
            <div className="card-title">
              <h5>Relatório de leitura</h5>
            </div>

            <div className="export-and-search-container">
              <Input
                className="search-input"
                type="text"
                placeholder="Pesquise"
                value={search}
                onChange={(e) => setSearch(e.target.value) > setCurrentPage(1)}
              />
              <Button
                color="success"
                //   onClick={() => createXlsx({ idEvent, countData: totalItems })}
              >
                Exportar Relatório
              </Button>
            </div>

            <div className="table-responsive">
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>ID do QRCode</th>
                    <th>Nome do Participante</th>
                    <th>Pontuação</th>
                    <th>Nome da Pontuação</th>
                    <th>Data e Hora</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>point.login?.id</td>
                    <td>point.login?.nome</td>
                    <td>point.pointing</td>
                    <td>point.pointingName</td>
                    <td>formatDate(point.createdAt)</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>

        <div
          style={{ display: "flex", alignSelf: "flex-end", marginRight: "5%" }}
        >
          <Pagination
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            totalItems={totalItems}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </>
  );
}
